import React, { ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';
import { Images } from '../../../@resources/img';
import { Colors, Grid } from '../../../ui';
import { Avatar } from '../../common/Avatar';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { ProfileModel } from '../../ProfileModel';


const Icon = styled.div<{ color?: string }>`
    position: absolute;
    top: 0;
    left: 0;
    padding: .375rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${p => p.color ?? 'none'};
    color: white;
    border-radius: 0.5rem;
`;

const chatMessageIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0.95);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;

const Message = styled.div<{ pre?: boolean }>`
    padding: .5rem 1rem;
    border-radius: .5rem;
    background: ${Colors.borderLight};
    animation: ${chatMessageIn} 0.3s ease-out;

    ${p => p.pre && `
        white-space: pre-wrap;
    `}
`;

const Actions = styled.div`
    display: flex;
    gap: 1rem;
`;

const Base = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const Actor = styled.div``;

const Block = ({ actor, children }: { actor: ReactNode, children: ReactNode }) => {
    return <Grid columns="3rem 1fr" columnGap="1">
        <Actor>{actor}</Actor>
        <Flexer flex="column" gap="1">
            {children}
        </Flexer>
    </Grid>;
};

const Seb = () => {
    return <Flexer>
        <img src={Images.LogoBlue} />
    </Flexer>;
};

const You = () => {
    const me = useResolve(ProfileModel);
    return <Avatar.ForUser user={me} />;
};

export const Chat = Object.assign(Base, {
    Block,
    Icon,
    Message,
    Actions,
    Seb,
    You,
});
